function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cn from 'classnames';
import range from 'lodash/range';
import Account from 'modules/Account';
import ClinicManagement from 'modules/ClinicManagement';
import { AppContext } from 'context';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import messages from '../../../messages';
import layoutStyles from '../MainLayout.pcss';
import styles from './ClinicSetLicence.pcss';
var _React_PureComponent;
class ClinicSetLicence extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        // eslint-disable-next-line react/prop-types
        const { isInProgress, hasErrors } = props;
        if (isInProgress !== state.isInProgress && (isInProgress || hasErrors)) {
            return {
                isInProgress
            };
        }
        return null;
    }
    componentDidMount() {
        if (this.inputs[0]) {
            this.inputs[0].focus();
        }
    }
    onSetLicenceKeyValue(value, number, remove) {
        const { licenceKeyChars } = this.state;
        const newLicenceKeyChars = JSON.parse(JSON.stringify(licenceKeyChars));
        newLicenceKeyChars[number] = value.replace(licenceKeyChars[number], '');
        this.setState({
            licenceKeyChars: newLicenceKeyChars
        });
        if (number < ClinicManagement.constants.LICENCE_LENGTH - 1 && !remove) {
            this.inputs[number + 1].focus();
        }
        if (number > 0 && remove) {
            this.inputs[number - 1].focus();
        }
    }
    onPaste(evt) {
        evt.preventDefault();
        evt.clipboardData.items[0].getAsString((text)=>{
            const licenceKeyChars = text.replaceAll('-', '').split('');
            this.setState({
                licenceKeyChars
            });
        });
    }
    onKeyDown(evt, number) {
        switch(evt.keyCode){
            case 8:
            case 46:
                evt.preventDefault();
                this.onSetLicenceKeyValue('', number, true);
                break;
            case 37:
                if (number > 0) {
                    this.inputs[number - 1].focus();
                }
                break;
            case 39:
                if (number < ClinicManagement.constants.LICENCE_LENGTH - 1) {
                    this.inputs[number + 1].focus();
                }
                break;
            case 13:
                this.onSubmit();
                break;
            default:
                break;
        }
    }
    onSetInputRef(el, i) {
        this.inputs[i] = el;
    }
    onSubmit() {
        const { onSetClinicLicence } = this.props;
        const { licenceKeyChars, isInProgress } = this.state;
        if (!this.isDisabled && !isInProgress) {
            const licenceKey = licenceKeyChars.map((character, index)=>{
                if (index % ClinicManagement.constants.LICENCE_PART_LENGTH === 0 && index !== 0) {
                    return `-${character}`;
                }
                return character;
            });
            onSetClinicLicence(this.clinic.clinicId, licenceKey.join(''));
        }
    }
    get isDisabled() {
        const { licenceKeyChars } = this.state;
        return licenceKeyChars.join('').trim().length !== ClinicManagement.constants.LICENCE_LENGTH;
    }
    get clinic() {
        const { clinic } = this.props.activeClinicMembership;
        return clinic;
    }
    renderLogo(clinic) {
        const { logo, name } = clinic;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.avatar,
            children: /*#__PURE__*/ _jsx(Avatar, {
                avatarImg: logo,
                name: name,
                className: styles.avatar__imgWrapper,
                imgClassName: styles.avatar__img,
                initialsClassName: styles.avatar__initials
            })
        });
    }
    renderInputs() {
        const { licenceKeyChars } = this.state;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.info,
            onPaste: (evt)=>this.onPaste(evt),
            children: range(ClinicManagement.constants.LICENCE_LENGTH).map((number)=>{
                const input = /*#__PURE__*/ _jsx("div", {
                    className: "input-container",
                    children: /*#__PURE__*/ _jsx("input", {
                        className: cn('form-control', styles.numberInput),
                        value: licenceKeyChars[number],
                        onChange: (evt)=>this.onSetLicenceKeyValue(evt.target.value, number),
                        onKeyDown: (evt)=>this.onKeyDown(evt, number),
                        ref: (el)=>this.onSetInputRef(el, number)
                    })
                }, `input-container-licence-${number}`);
                if (number % ClinicManagement.constants.LICENCE_PART_LENGTH === 0 && number !== 0) {
                    return /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex align-items-center justify-content-center",
                        children: [
                            "-",
                            input
                        ]
                    }, `input-container-licence-${number}-with-separator`);
                }
                return input;
            })
        });
    }
    renderAction() {
        return /*#__PURE__*/ _jsx(Button, {
            styleModifier: "primary",
            className: cn('btn--filled', styles.licenceButton),
            isInProgress: this.state.isInProgress,
            isDisabled: this.isDisabled,
            labelMessage: messages.buttons.setLicenceKey,
            onClick: ()=>this.onSubmit()
        });
    }
    renderContent() {
        const { activeClinicMembership } = this.props;
        if (activeClinicMembership.isAdmin) {
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.clinicLicence))
                    }),
                    this.renderInputs(),
                    this.renderAction()
                ]
            });
        }
        return /*#__PURE__*/ _jsx("p", {
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.clinicLicenceNotAdmin))
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: layoutStyles.container,
            children: /*#__PURE__*/ _jsx("div", {
                className: layoutStyles.containerInner,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "content",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.root,
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.header,
                                children: [
                                    this.renderLogo(this.clinic),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: styles.clinicName,
                                        children: this.clinic.name
                                    })
                                ]
                            }),
                            this.renderContent()
                        ]
                    })
                })
            })
        });
    }
    constructor(props){
        super(props);
        const licenceKeyChars = new Array(ClinicManagement.constants.LICENCE_LENGTH).map(()=>'');
        this.state = {
            isInProgress: false,
            licenceKeyChars
        };
        this.inputs = new Array(ClinicManagement.constants.LICENCE_LENGTH);
    }
}
_define_property(ClinicSetLicence, "contextType", AppContext);
_define_property(ClinicSetLicence, "propTypes", {
    // Explicit props
    activeClinicMembership: Account.shapes.clinicMembership,
    // Implicit props
    onSetClinicLicence: PropTypes.func
});
const mapStateToProps = (state)=>({
        isInProgress: ClinicManagement.selectors.isSetClinicLicenceInProgress(state),
        hasErrors: ClinicManagement.selectors.hasSetClinicLicenceErrors(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onSetClinicLicence: (clinicId, licenceKey)=>dispatch(ClinicManagement.actions.setClinicLicence(clinicId, licenceKey))
    });
const ConnectedClinicSetLicence = connect(mapStateToProps, mapDispatchToProps)(ClinicSetLicence);
export default withStyles(styles)(ConnectedClinicSetLicence);
